module.exports = __webpack_public_path__ + "img/Compounding_1200x800.68b8fb1c.png";